<template>
  <UserForm
    :label="`${t('changeMainUsername')} - ${t('establishmentServices')}`"
    :heading="$t('EnterNewEmailOrUsername')"
    registrationType="2"
  />
</template>

<script setup>
import UserForm from './UserForm.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()


</script>

<style lang="scss" scoped>
</style>